import { Confirmation } from 'lib/atoms/confirmationAtom';
import { useAtom } from 'jotai';
import confirmationAtom from 'lib/atoms/confirmationAtom';

export const useConfirm = () => {
  const [, setConfirmation] = useAtom(confirmationAtom);
  return (props: Confirmation) => setConfirmation(props);
};
